// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__9Otr-","colMaxWidth":"Table_colMaxWidth__3cjSh"};